import { Content } from './content';
import { LocalizedColumnName } from './localized-column-name';
import { TemplateRef } from '@angular/core';

export interface TwoRowConfig {
  primaryField: string;
  secondaryField: string;
  primaryFormatter?: (value: any) => string;
  secondaryFormatter?: (value: any) => string;
  primaryClasses?: string;
  secondaryClasses?: string;
  clickable?: boolean;
}

export interface TwoRowWithIconConfig extends TwoRowConfig {
  iconProperty: string;
  iconClasses?: string;
  clickable?: boolean;
}

export interface SingleRowWithIconConfig {
  valueField: string;
  iconProperty: string;
  iconClasses?: string;
  valueClasses?: string;
  clickable?: boolean;
}

// Two stacked SVG icons (mat-icon svgIcon). Each field resolves to a propertyValues entry
// whose `.value` is the SVG icon name and `.label` is the tooltip (same shape as MAT_ICON).
export interface TwoMatIconConfig {
  primaryField: string;
  secondaryField: string;
  clickable?: boolean;
}

export class TableItem {

  public cssClassesFlat: string;
  public headerIcon?: string;

  // Custom template support - allows full control over cell rendering
  public customTemplate?: TemplateRef<any>;
  public customContext?: any;

  // Configuration for new content types
  public twoRowConfig?: TwoRowConfig;
  public twoRowWithIconConfig?: TwoRowWithIconConfig;
  public singleRowWithIconConfig?: SingleRowWithIconConfig;
  public twoMatIconConfig?: TwoMatIconConfig;

  constructor(public cssClasses: string[],
              public localizedColumn: LocalizedColumnName | string,
              public propertyName: string,
              public content: Content = new Content(),
              customTemplate?: TemplateRef<any>,
              customContext?: any,
              twoRowConfig?: TwoRowConfig,
              twoRowWithIconConfig?: TwoRowWithIconConfig,
              singleRowWithIconConfig?: SingleRowWithIconConfig,
              twoMatIconConfig?: TwoMatIconConfig) {
                this.cssClasses = cssClasses.concat('item');
                this.cssClassesFlat = this.cssClasses.join(' ');
                this.customTemplate = customTemplate;
                this.customContext = customContext;
                this.twoRowConfig = twoRowConfig;
                this.twoRowWithIconConfig = twoRowWithIconConfig;
                this.singleRowWithIconConfig = singleRowWithIconConfig;
                this.twoMatIconConfig = twoMatIconConfig;
              }

  // public getItemClass(record: Entity): string {
  //   const baseClasses: string = this.cssClassesFlat + ' ' + 'item';
  //   if (record && this.propertyName) {
  //     let classDefinedClasses: string = record.getItemClassByProperty(this.propertyName);
  //     return classDefinedClasses = classDefinedClasses + ' ' + baseClasses;
  //   } else {
  //     return baseClasses;
  //   }
  // }
}
